'use client';

import type { ClawPassFromPage } from '@/app/components/shared/ClawPassContentDialog';
import { useGlobalModal } from '@/app/hooks';
import { useStore } from '@/app/providers/store';
import { shouldOpenPlanDetailFirst } from '../_utils/should-open-plan-detail';

export const useOpenPurchaseDialog = () => {
  const { open: openClawPassContentDialog } = useGlobalModal('clawPassContentDialog');
  const { open: openPlanDetailDialog } = useGlobalModal('planDetailDialog');
  const { userInfo, clawPass } = useStore((state) => ({
    userInfo: state.userInfo,
    clawPass: state.clawPass,
  }));

  return (fromPage: ClawPassFromPage) => {
    if (shouldOpenPlanDetailFirst(userInfo?.subs_plan, clawPass)) {
      openPlanDetailDialog({ fromPage });
    } else {
      openClawPassContentDialog({ fromPage });
    }
  };
};
